import React, { useState } from 'react';
import styled from 'styled-components';
import { UserDomain } from '@pomofocus/core';
import { ButtonText } from '../styles/Button';
import { OrLine } from '../common/OrLine';
import { AccountForm, ErrorMessageStyle, FormCardStyle, LabelStyle, SwitchPage, } from './LoginFormStyles';
import AccountFormShell from './AccountFormShell';
import EmailSent from './EmailSent';
import GoogleLoginButton from './GoogleLoginButton';
import { KEY_ENTER } from '../../constants';
import { Button } from '../common/Button';
export default function SignupForm({ activities, signupWithEmailSucceed, handleClickGoogle, submit, displayErrorMessage, errorMessage, handleClickSwitch, loginWithAuthCode, isElectron, }) {
    const [email, setEmail] = useState('');
    const checkError = () => {
        if (!UserDomain.validateEmail(email))
            return 'Please input valid email';
        return false;
    };
    const handleClickSubmit = () => {
        const _errorMessage = checkError();
        if (_errorMessage) {
            displayErrorMessage(_errorMessage);
        }
        else {
            submit(email, activities);
        }
    };
    const _handleClickGoogle = (idToken) => {
        handleClickGoogle(idToken, activities);
    };
    const handleKeyDownEmail = (e) => {
        if (e.key === KEY_ENTER) {
            handleClickSubmit();
        }
    };
    if (signupWithEmailSucceed) {
        return (React.createElement(EmailSent, { title: "Activation link have been sent", body: "Activation link have been sent to your email address. To\n        start using Pomofocus, please activate your account from\n        the link." }));
    }
    return (React.createElement(AccountFormShell, { title: "Create Account" },
        React.createElement(FormCard, null,
            React.createElement(React.Fragment, null,
                React.createElement(GoogleLoginWrapper, null,
                    React.createElement(GoogleLoginButton, { handleClickGoogle: _handleClickGoogle, loginWithAuthCode: loginWithAuthCode, isElectron: isElectron, title: "Signup with Google" })),
                React.createElement(OrLine, null)),
            React.createElement(Label, null, "Email"),
            React.createElement(Form, { value: email, placeholder: "example@mail.com", onChange: (e) => setEmail(e.target.value), onKeyDown: handleKeyDownEmail }),
            errorMessage && React.createElement(ErrorMessage, null, errorMessage),
            React.createElement(ButtonWrapper, null,
                React.createElement(Button, { onClick: handleClickSubmit, theme: "primary", size: "large", fullWidth: true }, "Sign up with Email"))),
        React.createElement(SwitchWrapper, null,
            React.createElement(SwitchText, null, "Already have an account?"),
            React.createElement(ButtonText, { styles: { fontSize: '17px' }, onClick: handleClickSwitch }, "Log in"))));
}
const FormCard = styled.div `
  ${FormCardStyle}
`;
const Label = styled.div `
  ${LabelStyle}
`;
const SwitchText = styled.div `
  margin-bottom: 8px;
`;
const ErrorMessage = styled.p `
  ${ErrorMessageStyle}
`;
const GoogleLoginWrapper = styled.div `
  margin-top: 18px;
`;
const ButtonWrapper = styled.div `
  margin-top: 28px;
`;
const Form = styled.input `
  ${AccountForm}
`;
const SwitchWrapper = styled.div `
  ${SwitchPage}
`;
